module.exports = __webpack_public_path__ + "static/media/ic_b_complex.d5db3527.svg";